import React, { useState, useEffect } from "react";
import Box from "../components/ui-kit/box";

import updateMetaTags from "../helpers/meta";

import "./Blog.scss";
import { translateString } from "../helpers/translator";

const REQUIRED_POST_CATEGORIES = {
  ro: [4, 7],
  en: [4, 8],
};

const fetchPosts = async (language) => {
  try {
    const requiredCategories =
      REQUIRED_POST_CATEGORIES[language] || REQUIRED_POST_CATEGORIES.en;

    const response = await fetch(
      `https://hosting.azasoftware.com/wp-json/wp/v2/posts?categories=${requiredCategories.join(",")}&per_page=100`
    );

    const posts = await response.json();

    // WordPress categories query behaves like OR, so we enforce AND here.
    return Array.isArray(posts)
      ? posts.filter((post) =>
          requiredCategories.every((categoryId) =>
            post?.categories?.includes(categoryId)
          )
        )
      : [];

  } catch (error) {
    console.error("Error fetching posts:", error);
    return [];
  }
};

const Blog = ({ type, language }) => {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    const getPosts = async () => {
      setArticles(await fetchPosts(language));
    };
    getPosts();
  }, [language]);

  useEffect(() => {
    updateMetaTags({
      title: `Blog - Aza Software`,
      description: translateString("BLOG.meta", language),
      image: "https://azasoftware.com/images/preview.jpg",
    });
  }, [language]);

  const languageInsert = language === "ro" ? "/ro" : "";

  return (
    <div className="blog-page">
      <div className="container">
        <Box className={`blog ${type ? `blog--${type}` : ""}`}>
          <h1>{translateString("BLOG.content.title", language)}</h1>
          <hr
            style={{
              borderTop: "1px solid #ededed",
              marginTop: "-30px",
              marginBottom: "40px",
            }}
          />
          {!articles || (articles.length === 0 && "LOADING")}
          {articles?.length
            ? articles.map((article) => (
                <a
                  key={article.slug}
                  href={`${languageInsert}/article/${article.slug}`}
                  className={`article-link ${
                    type === "small" && "article-link--small"
                  }`}
                  style={{ color: "white", textDecoration: "none" }}
                >
                  <article>
                    <h2 className="article-link__title">
                      <span
                        style={{
                          fontSize: "0.7em",
                          lineHeight: "1.2em",
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      >
                        📰
                      </span>{" "}
                      {article.title.rendered}
                    </h2>
                  </article>
                </a>
              ))
            : "No articles yet"}
        </Box>
      </div>
    </div>
  );
};

Blog.defaultProps = {
  type: "",
  className: "",
};

export default Blog;
